import { Controller } from "@hotwired/stimulus"

// Una riga di Organizzazioni.js (OrgRow): «Salva» del limite acceso solo se il numero cambia ed è almeno 1
// (Invio nel campo non salva, come l'Input senza form dell'originale); «Invita» apre e chiude il form d'invito.
export default class extends Controller {
  static targets = ["limite", "salva", "invito"]
  static values = { limite: Number }

  verifica() {
    const n = Number(this.limiteTarget.value)
    this.salvaTarget.disabled = n === this.limiteValue || n < 1
  }

  blocca(event) {
    event.preventDefault()
  }

  invita() {
    this.invitoTarget.hidden = !this.invitoTarget.hidden
  }
}
